import { Injectable, signal } from '@angular/core';

type ToastType = 'success' | 'error' | 'info' | 'warning';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  // Signals to drive the global toast component
  readonly visible = signal(false);
  readonly type = signal<ToastType>('info');
  readonly title = signal<string>('');
  readonly message = signal<string>('');

  show(type: ToastType, title: string, message: string): void {
    this.type.set(type);
    this.title.set(title);
    this.message.set(message);
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }
}


